import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Megaphone } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { API_URL } from './chatShared';

export const BroadcastDialog = ({ open, onClose, onSent }) => {
  const [text, setText] = useState('');
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    try {
      const { data } = await axios.post(`${API_URL}/chat/broadcast`, { text });
      toast.success(`Aviso enviado a ${(data.recipients || []).length} comerciais`);
      setText(''); onSent(data.conversation_id); onClose();
    } catch (e) { toast.error(e?.response?.data?.detail || 'Erro ao enviar aviso'); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="chat-broadcast-dialog" aria-describedby={undefined}>
        <DialogHeader><DialogTitle className="flex items-center gap-2"><Megaphone className="w-5 h-5 text-amber-600" />Aviso para todos os comerciais</DialogTitle></DialogHeader>
        <p className="text-xs text-slate-500">Cada comercial recebe o aviso no chat e numa janela, e tem de carregar em “Li e confirmo”. Vê quem já leu.</p>
        <textarea value={text} onChange={(e) => setText(e.target.value)} rows={5} maxLength={4000} placeholder="Escreva o aviso…"
          className="border border-slate-300 rounded-md px-3 py-2 text-sm" data-testid="chat-broadcast-text" />
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancelar</Button>
          <Button disabled={!text.trim() || busy} onClick={send} className="bg-amber-600 hover:bg-amber-700" data-testid="chat-broadcast-send">Enviar aviso</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
